module.exports = __webpack_public_path__ + "static/img/sign-point.4e359e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/sign-point.png
// module id = bFth
// module chunks = 0